import { Injectable } from "@angular/core";

@Injectable()
export class AgGridLocaleText {

    public static LocaleTextTR(): any {
        var localeTextTR = {
            // for filter panel
            page: 'Sayfa',
            more: 'Devamı',
            to: '-',
            of: 'Toplam: ',
            next: 'İleri',
            last: 'Son',
            first: 'İlk',
            previous: 'Sonraki',
            loadingOoo: 'Yükleniyor...',

            // for set filter
            selectAll: 'Tümünü seç',
            searchOoo: 'Ara...',
            blanks: 'Boş',

            // for number filter and text filter
            filterOoo: 'Ara...',
            applyFilter: 'Süzme...',
            equals: 'Eşittir',
            notEqual: 'Eşit Değilse',

            lessThan: 'Küçüktür',
            greaterThan: 'Büyüktür',
            lessThanOrEqual: 'Küçük eşit',
            greaterThanOrEqual: 'Büyük eşit',
            inRange: 'Aralık',

            // for text filter
            contains: 'İçeriyorsa',
            notContains: 'İçermiyorsa',
            startsWith: 'Başlıyorsa',
            endsWith: 'Bitiyorsa',

            // the header of the default group column
            group: 'Grup',

            // tool panel
            columns: 'Sütunlar',
            filters: 'Süzme',
            rowGroupColumns: 'Pivot Sütun',
            rowGroupColumnsEmptyMessage: 'Sütunları Gruba Sürükle',
            valueColumns: 'Sütun Değeri',
            pivotMode: 'Pivot-Modu',
            groups: 'Gruplar',
            values: 'Değerler',
            pivots: 'Pivotlar',
            valueColumnsEmptyMessage: ' toplamak için sütunları sürükleyin',
            pivotColumnsEmptyMessage: ' pivot için buraya sürükleyin',
            toolPanelButton: 'Araç çubuğu',

            // other
            noRowsToShow: 'Listelenecek veri mevcut değil',

            // enterprise menu
            pinColumn: 'Sütunu sabitle',
            valueAggregation: 'Değer',
            autosizeThiscolumn: 'Sığdır',
            autosizeAllColumns: 'Sütunları Otomatik Boyutlandır',
            groupBy: 'Grupla',
            ungroupBy: 'Gruplama',
            resetColumns: 'Sütunları Sıfırla',
            expandAll: 'Hepsini Aç',
            collapseAll: 'Hepsini Kapat',
            toolPanel: 'Araç Paneli',
            export: 'Çıkart',
            csvExport: 'CSV ye çıkar',
            excelExport: 'Excel e aktar',

            // enterprise menu pinning
            pinLeft: 'Sola sabitle',
            pinRight: 'Sağa sabitle',
            noPin: 'Sabitleme',

            // enterprise menu aggregation and status panel
            sum: 'Sum',
            min: 'En az',
            max: 'En çok',
            none: 'Yok',
            count: 'Say',
            verage: 'Ortalama',

            // standard menu
            copy: 'Kopyala',
            copyWithHeaders: 'Başlığı Kopyala',
            ctrlC: 'Ctrl C',
            paste: 'Yapıştır',
            ctrlV: 'Ctrl V'
        }

        return localeTextTR;
    }


}